module.exports = __webpack_public_path__ + "img/comment_white_36dp.f41a10ac.svg";